export const MY_REVIEW_ROUTE_NAME = 'accReviewsMyReviews'
